import { create } from 'zustand';
import { _getUserGroups } from '../data/users.js';

export const useGroupSummaryStore = create((set, get) => ({

    // State
    groups: {},
    lastFetched: null,
    cacheExpiration: 5 * 60 * 1000, // 5 minutes in milliseconds
    isLoading: false,

    // Actions
    setGroups: (groups) => set({
        groups,
        lastFetched: Date.now(),
        isLoading: false
    }),

    clearGroups: () => set({ groups: {}, lastFetched: null }),

    // Fetch groups with caching logic
    fetchGroups: async (force = false) => {
        const { groups, lastFetched, isLoading, cacheExpiration } = get();
        // Debug logging
        const isCacheExpired = !lastFetched || Date.now() - lastFetched > cacheExpiration;

        // Don't fetch if already loading
        if (isLoading) return groups;

        // Return cached data if not expired and not forcing refresh
        if (!force && Object.keys(groups).length > 0 && !isCacheExpired) {
            return groups;
        }

        try {
            set({ isLoading: true });
            const fetchedGroups = await _getUserGroups();
            set({
                groups: fetchedGroups,
                lastFetched: Date.now(),
                isLoading: false
            });
            return fetchedGroups;
        } catch (error) {
            set({ isLoading: false });
            throw error;
        }
    }
}));